import Typography from '@mui/material/Typography';

import { NO_DATA } from '../../../../consts/noData';

export default function NoDataCell() {
  return (
    <Typography component="span" variant="subtitle1">
      {NO_DATA}
    </Typography>
  );
}
